export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiaW1hZ2VzL2ljLXBsYW4tdmVuZGVlLWVhdS1ldmVuZW1lbnQuc3ZnIjs="